import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils/cn';

const badgeVariants = cva(
    'inline-flex items-center rounded-md border px-1.5 py-0.5 font-mono text-2xs font-medium leading-none transition-colors duration-fast',
    {
        variants: {
            tone: {
                neutral: 'border-border bg-muted text-foreground',
                muted: 'border-border bg-background text-muted-foreground',
                terracotta: 'border-terracotta/30 bg-terracotta/10 text-terracotta',
                emerald: 'border-emerald/30 bg-emerald/10 text-emerald',
                gold: 'border-gold/30 bg-gold/10 text-gold',
                destructive: 'border-destructive/30 bg-destructive/10 text-destructive',
            },
        },
        defaultVariants: {
            tone: 'neutral',
        },
    },
);

export interface BadgeProps
    extends HTMLAttributes<HTMLSpanElement>,
        VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
    return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
